"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[970],{

/***/ 4503:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_Body; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
;// CONCATENATED MODULE: ./src/themes/default/components/Body/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-self: center;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  justify-content: flex-start;\n  align-content: flex-start;\n  width: 100%;\n  max-width: ",
        ";\n  padding: ",
        "\n    ",
        ";\n\n  @media (max-width: 768px) {\n    padding: ",
        "\n      ",
        ";\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}

const Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-22ac003b-0"
})(_templateObject(), (p)=>p.theme.maxWidth, (p)=>p.hasSpacingY ? p.theme.spacing.xLarge : 0, (p)=>p.theme.spacing.xLarge, (p)=>p.hasSpacingY ? p.theme.spacing.medium : 0, (p)=>p.theme.spacing.medium);

;// CONCATENATED MODULE: ./src/themes/default/components/Body/index.tsx


const Body = (param)=>{
    let { hasSpacingY , children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        className: "Body",
        hasSpacingY: hasSpacingY,
        children: children
    });
};
/* harmony default export */ var components_Body = (Body);


/***/ })

}]);